import * as React from 'react'

import { XIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import SharedDeliveriesStore from '~/client/src/shared/stores/domain/SharedDeliveries.store'
import SharedSitePermitStore from '~/client/src/shared/stores/domain/SharedSitePermit.store'

import MobileCommonStore from '../../stores/ui/MobileCommon.store'

interface IProps {
  common: MobileCommonStore
  sharedSitePermitStore?: SharedSitePermitStore
  sharedDeliveriesStore?: SharedDeliveriesStore
  entityId: string
  onBackClick: () => void
  renderActions: () => JSX.Element
}

export const EntitySharedView: React.FC<IProps> = ({
  onBackClick,
  renderActions,
}) => {
  const renderSharedEntityHeader = (): JSX.Element => {
    return (
      <div className="row pa10 pl20 bb-light-grey">
        <Button
          variant="ghost"
          size="icon"
          className="tw:flex-none!"
          aria-label={Localization.translator.close}
          onClick={onBackClick}
        >
          <XIcon />
        </Button>
        <div className="col x-center ml10 mr30">
          <div className="text large">
            {Localization.translator.workflowDetails}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {renderSharedEntityHeader()}
      {renderActions()}
    </>
  )
}

export const defaultHandlers = {
  handleLinkClick: (e: React.MouseEvent, url: string): void => {
    e.preventDefault()
    if (url) {
      window.open(url, '_blank')
    }
  },
  handleCallTo: (phone: string): void => {
    if (phone) {
      window.location.href = `tel:${phone}`
    }
  },
  handleMailTo: (email: string): void => {
    if (email) {
      window.location.href = `mailto:${email}`
    }
  },
}
